/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Fact_Year_BuiltInputs */

const cs_public_site_fact_year_built = /** @type {(inputs: Public_Site_Fact_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rok výstavby`)
};

const en_public_site_fact_year_built = /** @type {(inputs: Public_Site_Fact_Year_BuiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Year built`)
};

/**
* | output |
* | --- |
* | "Year built" |
*
* @param {Public_Site_Fact_Year_BuiltInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_fact_year_built = /** @type {((inputs?: Public_Site_Fact_Year_BuiltInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Fact_Year_BuiltInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_fact_year_built(inputs)
	return cs_public_site_fact_year_built(inputs)
});